import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  'default-page-title': {
    id: 'pm.default-page-title',
    defaultMessage: 'PM | Cloudinary',
  },
  'developer-dashboard': {
    id: 'pm.developer-dashboard',
    defaultMessage: 'Developer Dashboard',
  },
  'getting-started': {
    id: 'pm.getting-started',
    defaultMessage: 'Getting Started',
  },
  'manage-and-analyze': {
    id: 'pm.manage-and-analyze',
    defaultMessage: 'Manage and Analyze',
  },
  beta: {
    id: 'pm.beta',
    defaultMessage: 'Beta',
  },
  'media-explorer': {
    id: 'pm.media-explorer',
    defaultMessage: 'Media Explorer',
  },
  'media-library-confirmation-title': {
    id: 'pm.media-library-confirmation-title',
    defaultMessage: 'Navigate to Media Library',
  },
  'media-library-confirmation-text': {
    id: 'pm.media-library-confirmation-text',
    defaultMessage: 'You are about to be navigated out of Programmable Media, do you want to continue anyway?',
  },
  'media-library-confirmation-confirm': {
    id: 'pm.media-library-confirmation-confirm',
    defaultMessage: 'Yes, please',
  },
  'media-library-confirmation-cancel': {
    id: 'pm.media-library-confirmation-cancel',
    defaultMessage: 'No, I prefer to stay here',
  },
  'transformation-builder': {
    id: 'pm.transformation-builder',
    defaultMessage: 'Transformation Builder',
  },
  'transformation-suite': {
    id: 'pm.transformation-suite',
    defaultMessage: 'Transformation Suite',
  },
  'optimization-reports': {
    id: 'pm.optimization-reports',
    defaultMessage: 'Optimization Reports',
  },
  'optimization-reports-menu-label': {
    id: 'pm.optimization-reports-menu-label',
    defaultMessage: 'Reports',
  },
  'optimization-center': {
    id: 'pm.optimization-center',
    defaultMessage: 'Optimization Overview',
  },
  'optimization-center-menu-label': {
    id: 'pm.optimization-center-menu-label',
    defaultMessage: 'Overview',
  },
  dashboard: {
    id: 'pm.dashboard',
    defaultMessage: 'Dashboard',
  },
  loading: {
    id: 'pm.loading',
    defaultMessage: 'Loading...',
  },
  transformations: {
    id: 'pm.transformations',
    defaultMessage: 'Transformations',
  },
  'transformations-center': {
    id: 'pm.transformations-center',
    defaultMessage: 'Transformation Center',
  },
  'transformations-manage': {
    id: 'pm.transformations-manage',
    defaultMessage: 'Manage Transformations',
  },
  'transformation-log': {
    id: 'pm.transformation-log',
    defaultMessage: 'Transformation Log',
  },
  'new-transformation': {
    id: 'pm.new-transformation',
    defaultMessage: 'New Transformation',
  },
  'video-app-link': {
    id: 'pm.videoAppLink',
    defaultMessage: 'Go to Video Home',
  },
  'video-app-link-tag': {
    id: 'pm.videoAppLinkTag',
    defaultMessage: 'NEW',
  },
  'video-section': {
    id: 'pm.videoSection',
    defaultMessage: 'Video',
  },
  'video-hub': {
    id: 'pm.videoHub',
    defaultMessage: 'Overview',
  },
  'video-player-studio': {
    id: 'pm.videoPlayerStudio',
    defaultMessage: 'Player',
  },
  'video-player-profiles': {
    id: 'pm.videoPlayerProfiles',
    defaultMessage: 'Profiles',
  },
  reports: {
    id: 'pm.reports',
    defaultMessage: 'Reports',
  },
  'delivery-reports': {
    id: 'pm.delivery-reports',
    defaultMessage: 'Delivery Reports',
  },
  'video-player-reports': {
    id: 'pm.video-player-reports',
    defaultMessage: 'Analytics',
  },
  'usage-reports': {
    id: 'pm.usage-reports',
    defaultMessage: 'Usage Reports',
  },
  'error-reports': {
    id: 'pm.error-reports',
    defaultMessage: 'Error Reports',
  },
  'monthly-value-reports': {
    id: 'pm.monthly-value-reports',
    defaultMessage: 'Monthly Value Report',
  },
  'media-library': {
    id: 'pm.media-library',
    defaultMessage: 'Media Library',
  },
  'structured-metadata': {
    id: 'pm.structured-metadata',
    defaultMessage: 'Structured Metadata',
  },
  'transform-and-customize': {
    id: 'pm.transform-and-customize',
    defaultMessage: 'Transform and Customize',
  },
  'optimize-and-deliver': {
    id: 'pm.optimize-and-deliver',
    defaultMessage: 'Optimize and Deliver',
  },
  'optimization-preferences': {
    id: 'pm.optimization-preferences',
    defaultMessage: 'Optimization Preferences',
  },
  'dont-show-this-again': {
    id: 'pm.dont-show-this-again',
    defaultMessage: 'Don’t show this again',
  },
  'page-not-found-title': {
    id: 'pm.page-not-found-title',
    defaultMessage: 'Page not found',
  },
  'page-not-found-action': {
    id: 'pm.page-not-found-action',
    defaultMessage: 'Go to Dashboard',
  },
  'page-access-denied-title': {
    id: 'pm.page-access-denied-title',
    defaultMessage: 'Access denied',
  },
  'page-access-denied-subtitle': {
    id: 'pm.page-access-denied-subtitle',
    defaultMessage: "You don't have permission to view this page",
  },
  'page-access-denied-action': {
    id: 'pm.page-access-denied-action',
    defaultMessage: 'Go to Dashboard',
  },
});
